import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import HoverableWrapper from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverableWrapper';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import ErrorBoundary from '../../../../ErrorBoundary';
import DeviationDumbView from '../../../Dumbo';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import { DeviationTypes } from '../../../../types/deviation';
import { useTranslation } from 'react-i18next';
import { getTranslationKeyForAccessibleDeviationLink } from '../../helpers';
import Overlay from '../../legos/Overlay';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { getDeviationType } from '../../../_helpers';
import useDeviationDrag from '../../../../Dnd/useDeviationDrag';
import s from './Default.scss';
var Default = function (_a) {
    var className = _a.className, deviation = _a.deviation, height = _a.height, responsive = _a.responsive, style = _a.style, width = _a.width, extraActions = _a.extraActions, onRemove = _a.onRemove;
    var t = useTranslation().t;
    var _b = useOverlayContext(deviation), showOverlayTitle = _b.showTitle, showOverlay = _b.showOverlay, __forceHoveredForStories = _b.__forceHoveredForStories;
    var _c = useDeviationDrag({
        deviation: deviation,
        width: width,
        height: height,
    }), dragPreview = _c.dragPreview, drag = _c.drag;
    var type = getDeviationType(deviation);
    var linkAsWrapper = type === DeviationTypes.IMAGE;
    var a11yLabel = getTranslationKeyForAccessibleDeviationLink(t, deviation);
    return (React.createElement(React.Fragment, null,
        dragPreview,
        React.createElement(HoverableWrapper, { className: classnames(s['root'], className), style: __assign({ width: width, height: height }, style), "data-hook": BiDataHook.DEVIATION_STD_THUMB, ref: drag, __forceHoveredForStories: __forceHoveredForStories },
            React.createElement(ErrorBoundary, { debugComponent: "StandardThumbDefault" },
                /*
                Because we don't always show a title inside of the overlay,
                we'll place this here to avoid any untitled sections polluting the document outline
              */
                !showOverlayTitle && (React.createElement(VisuallyHidden, null,
                    React.createElement(Heading, null, a11yLabel))),
                linkAsWrapper ? (React.createElement(DeviationLink, { "aria-label": a11yLabel, deviation: deviation },
                    React.createElement(DeviationDumbView, { deviation: deviation, width: width, height: height, responsive: responsive, "aria-hidden": "true" }))) : (React.createElement(React.Fragment, null,
                    React.createElement(DeviationDumbView, { deviation: deviation, width: width, height: height, responsive: responsive, "aria-hidden": "true" }),
                    React.createElement(DeviationLink, { deviation: deviation, className: s['link-overlay'], title: deviation.title, "aria-label": a11yLabel },
                        React.createElement("span", null)))),
                showOverlay && (React.createElement(Overlay, { deviation: deviation, width: width, height: height, className: s['overlay'], extraActions: extraActions, "aria-hidden": "true", onRemove: onRemove }))))));
};
Default.displayName = 'Default';
export default Default;
//# sourceMappingURL=Default.js.map